/* irshaid-motion.js — Lenis smooth scroll + GSAP heading reveal.
   Loaded after gsap, ScrollTrigger and lenis. Every branch fails safe: if a
   library is missing, the user prefers reduced motion, the page is the
   viewing room (it runs its own scroll engine), or the theme editor is open,
   nothing happens and the theme behaves exactly as before. */
(function () {
  'use strict';
  var root = document.documentElement;

  function reveal(el) { el.setAttribute('data-im-done', ''); }
  function revealAll() {
    document.querySelectorAll('#MainContent h1').forEach(reveal);
  }

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var editor = window.Shopify && window.Shopify.designMode;
  var viewingRoom = !!document.querySelector('[data-vr-walk]');

  if (reduce || editor || viewingRoom || !window.gsap) { revealAll(); return; }

  var hasST = !!window.ScrollTrigger;
  if (hasST) gsap.registerPlugin(ScrollTrigger);

  /* ---------- Lenis: wheel smoothing, desktop pointers only ---------- */
  var fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  if (window.Lenis && fine) {
    var lenis = new Lenis({
      lerp: 0.1,
      wheelMultiplier: 1,
      anchors: true,
      prevent: function (node) {
        return !!(node.closest && node.closest(
          '[data-lenis-prevent], cart-drawer, .cart-drawer, product-modal, header-drawer, ' +
          'details-modal, [role="dialog"], predictive-search, .mega-menu, .vr-drawer, textarea, select'
        ));
      }
    });
    root.classList.add('lenis-on');
    window.irshaidLenis = lenis;

    if (hasST) lenis.on('scroll', ScrollTrigger.update);
    gsap.ticker.add(function (t) { lenis.raf(t * 1000); });
    gsap.ticker.lagSmoothing(0);

    /* Dawn locks the page with body.overflow-hidden* when a drawer, modal or
       menu opens. Hand scrolling back to the browser while any is open. */
    var syncLock = function () {
      var locked = /\boverflow-hidden/.test(document.body.className);
      if (locked) lenis.stop(); else lenis.start();
    };
    new MutationObserver(syncLock).observe(document.body, { attributes: true, attributeFilter: ['class'] });
    syncLock();
  }

  /* ---------- Heading reveal (word blur-in, after React Bits BlurText) ---------- */
  var ARABIC = /[؀-ۿݐ-ݿﭐ-﷿ﹰ-﻿]/;

  document.querySelectorAll('#MainContent h1').forEach(function (h) {
    var text = h.textContent.replace(/\s+/g, ' ').trim();
    var plainKids = Array.prototype.every.call(h.children, function (c) { return c.classList.contains('visually-hidden'); });
    /* plain single-script text only: Arabic must not be split (breaks
       joining), and other nested markup would be flattened. A visually-hidden
       prefix (Dawn's "Collection:") is left as is. */
    if (!text || ARABIC.test(text) || !plainKids || h.closest('[class*="vr-"]')) { reveal(h); return; }

    var words = [];
    Array.prototype.slice.call(h.childNodes).forEach(function (n) {
      if (n.nodeType !== 3 || !n.textContent.trim()) return;
      var frag = document.createDocumentFragment();
      n.textContent.trim().split(/\s+/).forEach(function (w, i, a) {
        var s = document.createElement('span');
        s.className = 'im-word';
        s.textContent = w;
        words.push(s);
        frag.appendChild(s);
        if (i < a.length - 1) frag.appendChild(document.createTextNode(' '));
      });
      h.replaceChild(frag, n);
    });
    if (!words.length) { reveal(h); return; }
    reveal(h);

    var tween = {
      opacity: 0, y: 14, filter: 'blur(6px)',
      duration: 0.9, ease: 'power3.out', stagger: 0.06,
      clearProps: 'opacity,transform,filter,willChange'
    };
    var below = h.getBoundingClientRect().top > window.innerHeight * 0.9;
    if (below && hasST) {
      tween.scrollTrigger = { trigger: h, start: 'top 90%', once: true };
    }
    gsap.from(words, tween);
  });
})();
